import PickModalClass from "../common/PickModalClass";
import ToolsClass from "./ToolsClass";
import Util from "../../libs/util/Util";

/**
 * 絞り込みモーダル
 */
export default class ToolsModalClass extends PickModalClass{
    constructor(_parent){
        super("sort_refile_hotel",_parent);
        this.name = "ToolsModalClass";

        this.isToolsBtnVisible = false;
    }

    onCreate() {
        super.onCreate();

        this.target = this.modal;

        this.tools = new ToolsClass($(".tools",this.modal));

        this.toolsSubmitButton = $(".button .positive",this.modal);

        this.tools.on(this.tools.EVENT_CHANGE,(e,p)=>{
            this.onToolsBtnActiveChange(p.flag);
        });

        this.tools.onCreate();

        this.btnReset = $(".button .negative",this.modal);
        this.btnReset.on("click",this.onClick_reset.bind(this));

        this.form = $("form",this.modal);
    }

    onResize(_size) {
        if(Util.isBreakpoint) {
            this.tools.onResize();
            return;
        }

        let offset = this.clickTarget.not(":hidden").offset();
        let position;
        const parentOffset = $(this.parent).offset();
        if(!offset) {
            let top = (_size.h - this.modal.height()) / 2;
            top += Util.getScrollY();
            position = {top:top};
        } else {
            position = {top:offset.top - parentOffset.top};
        }
        position.left = 0;

        this.modal.css(position);

        this.tools.onResize();
    }

    onSetDefaultData(_json){
        this.tools.onSetDefaultData(_json);
    }

    onOpenAfter() {
        super.onOpenAfter();
        this.tools.onResize();
    }

    onToolsBtnActiveChange(_flag){
        if(this.isToolsBtnVisible === _flag) return;
        if(_flag){
            this.toolsSubmitButton.removeClass("disable");
        } else {
            this.toolsSubmitButton.addClass("disable");
        }
        this.isToolsBtnVisible = _flag;
    }

    onClick_reset(){
        this.tools.onReset();
    }
}